"use client";

import { createContext, useContext } from "react";
import type { CompanyContact } from "@/lib/company";

// Default mirrors COMPANY_CONTACT_FALLBACK so client components are safe even if
// rendered outside the provider. (`import type` above is erased at build time,
// so the server-only @/lib/company module never reaches the client bundle.)
const FALLBACK: CompanyContact = {
  phone: "+370 660 79770",
  phoneHref: "tel:+37066079770",
  email: "info@autobook.lt",
};

const CompanyContext = createContext<CompanyContact>(FALLBACK);

export function CompanyProvider({
  value,
  children,
}: {
  value: CompanyContact;
  children: React.ReactNode;
}) {
  return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

/** Company phone + email (from Directus company_settings), provided by the root layout. */
export function useCompany(): CompanyContact {
  return useContext(CompanyContext);
}
